import { css } from '@bts-web/utils-style-engine';
import { intlFiatValueFormatting } from '@bts-web/utils-formatting';
import { SavingsPlanStatus } from '@bts-web/data-layer/server';
import { getAppConfig } from '@bts-web/core-app-config';
import { SavingsPlanDetailsTranslations } from '../utils/getSavingsPlanDetailsTranslations';
import { SavingsPlanDetailsFooter } from '../components/SavingsPlanDetailsFooter/SavingsPlanDetailsFooter.use-client';
import { SavingsPlanDetailsWrapper } from '../SavingsPlanDetailsWrapper/SavingsPlanDetailsWrapper';
import { TransactionDetailsTitle } from '../../../transaction-details';
import { SavingsPlanType } from '../SavingsPlanDetailsController/SavingsPlanDetailsController.server';
import { AssetImage } from '../../../common';
import { SavingsPlansLatestTransactionsContent } from '../../SavingsPlansLatestTransactionsContent/SavingsPlansLatestTransactionsContent';
import { ComponentProps } from 'react';

export interface SavingsPlansDetailsContentProps {
  translations: SavingsPlanDetailsTranslations;
  savingsPlan: SavingsPlanType;
  locale: string;
  latestTransactionData: ComponentProps<
    typeof SavingsPlansLatestTransactionsContent
  >['latestTransactionsData'];
  currency?: string;
}

export const SavingsPlansDetailsContent = ({
  translations,
  savingsPlan,
  locale,
  latestTransactionData,
}: SavingsPlansDetailsContentProps) => {
  const { currency } = getAppConfig();

  return (
    <>
      <TransactionDetailsTitle
        title={
          <span
            className={css({
              display: 'flex',
              gap: 'extra_small_2',
              lineHeight: 'label.medium_medium',
              letterSpacing: 'label.medium_medium',
              fontWeight: 'label.medium_medium',
              fontSize: 'label.medium_medium',
            })}
          >
            <AssetImage
              testId="logo-header"
              height={24}
              width={24}
              alt={savingsPlan?.asset?.name as string}
              src={savingsPlan?.asset?.logoUrl as string}
            />
            {savingsPlan?.asset?.name}
          </span>
        }
        subtitle={
          savingsPlan?.fiatAmount?.value && (
            <div
              className={css({
                fontSize: 'headline.medium_medium',
                pt: 'extra_small',
              })}
            >
              {intlFiatValueFormatting(savingsPlan?.fiatAmount?.value, {
                locale,
                currency,
                fractionDigits: savingsPlan?.fiatAmount?.precision,
              })}
            </div>
          )
        }
      />

      <SavingsPlanDetailsWrapper
        savingsPlan={savingsPlan}
        locale={locale}
        currency={currency}
        translations={translations}
      />

      <SavingsPlansLatestTransactionsContent
        latestTransactionsData={latestTransactionData ?? []}
        applicationLocale={locale}
        translations={translations}
        savingsPlanId={savingsPlan.id}
      />

      <SavingsPlanDetailsFooter
        translations={translations}
        savingsPlan={{
          id: savingsPlan?.id as string,
          name: savingsPlan?.name as string,
          status: savingsPlan?.status as SavingsPlanStatus,
        }}
        isConfirmedTransaction={
          latestTransactionData?.edges?.[0]?.node?.state === 'CONFIRMED'
        }
      />
    </>
  );
};
